export default "__VITE_ASSET__2a2621eb__"